import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import ScheduleLandingComponent from "./components/ScheduleLandingComponent";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useTranslation } from "@i18n";
import ReserveAppointment from "./components/ReserveAppointment";
import OrderCanceled from "./components/OrderCanceled";
import CarChecked from "./components/CarChecked";
import AppointmentScheduled from "./components/AppointmentScheduled";
import TechnicalError from "./components/TechnicalError";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { appointmentView } from "@/apis/scheduleApis/appointmentView";
import { useEffect } from "react";
import Loader from "@componentsShared/Loader/Loader";
import useHelpers from "@hooks/useHelpers";
import useWebView from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
var Schedule = function Schedule(_ref) {
  var _pageData$status, _pageData$status2;
  var request_Id = _ref.request_Id;
  var navigate = useNavigate();
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  //////////////////////////
  var params = useParams();
  var requestId = params.request_id || request_Id;
  //////////////////////////
  var location = useLocation();
  var queryParams = new URLSearchParams(location.search);
  var scheulestep = queryParams.get("schedulestep") || null;
  //////////////////////////
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    pageData = _React$useState2[0],
    setPageData = _React$useState2[1];
  var webview = useWebView();
  var isWebView = useIsWebView();
  useEffect(function () {
    if (requestId) {
      appointmentView(requestId).then(function (res) {
        var _res$status, _res$status2;
        if (!res) {
          navigate(createUrl("/schedule/".concat(requestId), {
            schedulestep: "error"
          }));
          return;
        }
        setPageData(res);
        if (!scheulestep || (res === null || res === void 0 ? void 0 : (_res$status = res.status) === null || _res$status === void 0 ? void 0 : _res$status.toLowerCase()) === "cancelled" || (res === null || res === void 0 ? void 0 : (_res$status2 = res.status) === null || _res$status2 === void 0 ? void 0 : _res$status2.toLowerCase()) === "done") {
          var _res$status3;
          navigate(createUrl("/schedule/".concat(requestId), {
            schedulestep: res === null || res === void 0 ? void 0 : (_res$status3 = res.status) === null || _res$status3 === void 0 ? void 0 : _res$status3.toLowerCase()
          }));
        }
        console.log("view data:", res);
      })["catch"](function (error) {
        console.log("appointmentView error", error);
        navigate(createUrl("/schedule/".concat(requestId), {
          schedulestep: "error"
        }));
      });
    }
  }, [requestId]); // intentionally excludes scheulestep — effect should only run on mount/requestId change, not on every URL step change

  useEffect(function () {
    if (scheulestep == 'reschedule') {
      webview.showTitleBar(false)["catch"](function () {
        if (isWebView) {
          /** @FIXME TEMP Solution to hide Header for webview on old version ticket [SE-5723] **/
          document.body.classList.add("FIX_ME_OLD_ANDROID_IN_APP_WEBVIEW");
        }
      });
      return function () {
        if (isWebView) {
          /** @FIXME TEMP Solution to hide Header for webview on old version ticket [SE-5723] **/
          document.body.classList.remove("FIX_ME_OLD_ANDROID_IN_APP_WEBVIEW");
        }
      };
    } else {
      webview.showTitleBar(true)["catch"](function () {});
    }
  }, [isWebView, scheulestep]);
  useEffect(function () {
    console.log('====================================');
    console.log(pageData);
    console.log('====================================');
  }, [pageData]);
  var _useTranslation = useTranslation(["web_Schedule"]),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !pageData && scheulestep !== "error" && /*#__PURE__*/React.createElement(Loader, null), /*#__PURE__*/React.createElement(Layout
  // hideHeaderOnmobile
  // custommobileHeader={isMobile && MobileHeader()}
  , {
    disableLoader: true,
    hideAppBanner: true,
    linksForSearch: true,
    hideOrangeHeadBtn: true,
    hideMenu: true,
    hideFooterWithoutAuthMsg: true,
    hideBurgerMenu: true,
    authenticationMsg: true,
    headHideLinks: true,
    mainClass: "dealersDetailed"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingBottom: "120px"
    }
  }, (scheulestep === "exist" || scheulestep === "new") && /*#__PURE__*/React.createElement(ScheduleLandingComponent, {
    pageData: pageData,
    t: t,
    navigate: navigate,
    requestId: requestId,
    scheulestep: scheulestep
  }), scheulestep === "reschedule" && /*#__PURE__*/React.createElement(ReserveAppointment, {
    requestId: requestId
  }), scheulestep === "success" && /*#__PURE__*/React.createElement(AppointmentScheduled, {
    pageData: pageData,
    t: t,
    navigate: navigate,
    requestId: requestId
  }), scheulestep === "cancelled" && /*#__PURE__*/React.createElement(OrderCanceled, {
    pageData: pageData,
    text: (pageData === null || pageData === void 0 ? void 0 : (_pageData$status = pageData.status) === null || _pageData$status === void 0 ? void 0 : _pageData$status.toLowerCase()) === "cancelled" || (pageData === null || pageData === void 0 ? void 0 : (_pageData$status2 = pageData.status) === null || _pageData$status2 === void 0 ? void 0 : _pageData$status2.toLowerCase()) === "new" ? t("order_cancelled", {
      ns: "web_Schedule"
    }) : t("request_canceled", {
      ns: "web_Schedule"
    }),
    requestId: requestId
  }), scheulestep === "done" && /*#__PURE__*/React.createElement(CarChecked, {
    pageData: pageData,
    t: t,
    navigate: navigate,
    requestId: requestId
  }), scheulestep === "error" && /*#__PURE__*/React.createElement(TechnicalError, {
    text: t("error_technical_error_occurred", {
      ns: "web_Schedule"
    })
  }))));
};
export default Schedule;